// eslint-disable-next-line import/no-cycle
import { Skill } from 'src/services/jobs/jobs.types';

import { PageOptions, PaginatedResponse } from '../api.types';

export enum EntityLabelScopeType {
  SYSTEM = 'system',
  TENANT = 'tenant',
}

export enum EntityLabelType {
  COMPANY = 'company',
  CANDIDATE = 'candidate'
}

export interface Country {
  id: string;
  created_at: string;
  updated_at: string;
  name: string;
  code: string;
  region: string;
}

export interface FileResponse {
  id: string;
  name: string;
  public_path: string;
  type: string;
  mime: string;
  created_at: Date;
}

export interface Category {
  id: string;
  name: string;
}

export type CategoryResponse = PaginatedResponse<Category>;

export type SearchCategoryProps = {
  name: string;
} & PageOptions;

export interface Currency {
  id: string;
  name: string;
  code: string;
}

export type CurrencyResponse = Currency[];

export type GetSkillsProps = {
  name: string;
} & PageOptions;

export type SearchLabelsProps = {
  label?: string;
  type: EntityLabelType;
} & PageOptions;

export type SearchBusinessInfoProps = {
  query: string,
  countryCode: string,
}

export interface BusinessIDSearchResponse {
  tax_id: string;
  entity_name: string;
  business_names: string[];
}

export interface BusinessOption {
  business_name: string;
  tax_id: string;
}

export interface BusinessEntity {
  tax_id: string;
  name: string;
  type: string;
  score: number;
  address: {
    state: string;
    postcode: string;
  }
}

export interface BusinessNameSearchResponse {
  results: BusinessEntity[];
}

export type EntityLabel = {
  id: string;
  label?: string;
  type?: EntityLabelType;
  scope_type?: EntityLabelScopeType;
};

export type CreateLabelDto = {
  label: string;
  type: EntityLabelType;
  scope_type: EntityLabelScopeType;
};

export type UpdateLabelDto = {
  id: string;
  label: string;
  // Carried only so the mutation can invalidate the right EntityLabels cache tag.
  type: EntityLabelType;
};

export type DeleteLabelDto = {
  id: string;
  // Carried only so the mutation can invalidate the right EntityLabels cache tag.
  type: EntityLabelType;
};

export type SkillsResponse = PaginatedResponse<Skill>;

export type EntityLabelResponse = PaginatedResponse<EntityLabel>;
